export default __webpack_public_path__ + "static/cr_thumb-4afc3b7f7b9685df13e20045fb30d51c.png";